import { Component, Input, OnInit } from '@angular/core';
import { coerceNumberProperty } from '@angular/cdk/coercion';


@Component({
  selector: 'app-data-loading',
  template: `<mat-spinner [diameter]="size"></mat-spinner>`,
  host: {
    style: 'z-index: 101;',
    'class': 'd-flex align-items-center justify-content-center w-100 position-absolute start-0 end-0 top-0 bottom-0'
  }
})
export class DataLoadingComponent {
  @Input()
  set size(value: any) {
    this._size = coerceNumberProperty(value);
  };
  get size(): number {
    return this._size;
  };

  private _size: number = 24;
}
